<youtube-player
	[class.w-100]="fullSize"
	[class.h-100]="fullSize"
	[videoId]="videoId"
	[playerVars]="playerVars"
	[suggestedQuality]="'highres'"
	[disableCookies]="true"
	[startSeconds]="startSeconds"
	[endSeconds]="endSeconds"
	[width]="youtubePlayerWidth"
	[height]="youtubePlayerHeight"
	(ready)="onVideoReady($event)"
	(stateChange)="onVideoStateChange($event)"
></youtube-player>

<!-- 
<reach-logo-loader
	*ngIf="loading"
	[spinning]="true"
	style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1;"
></reach-logo-loader> 
-->
